var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TitleTextBox"},[_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.$_cmsSupport_hasContentSlotWithName('content'))?_c('div',[_vm._t("content")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }